import { refreshIcons } from '../base/utils.js';

export function initSidebar() {
    const sidebar = document.getElementById('sidebar');
    const toggleBtn = document.getElementById('sidebar-toggle');
    const toggleBtnMobile = document.getElementById('sidebar-toggle-mobile');
    const closeBtnMobile = document.getElementById('sidebar-close-mobile');
    const overlay = document.getElementById('sidebar-overlay');
    const sidebarLinks = document.querySelectorAll('.sidebar-link');

    if (!sidebar) return;

    function updateSidebarToggleIcon(isCollapsed) {
        if (!toggleBtn) return;
        const iconName = isCollapsed ? 'panel-right' : 'panel-left';
        toggleBtn.innerHTML = `<i data-lucide="${iconName}" class="w-5 h-5"></i>`;
        refreshIcons(toggleBtn);
    }

    function toggleSidebar() {
        if (window.innerWidth >= 1024) {
            sidebar.classList.toggle('collapsed');
            const isCollapsed = sidebar.classList.contains('collapsed');
            localStorage.setItem('sidebarCollapsed', isCollapsed);
            updateSidebarToggleIcon(isCollapsed);
        } else {
            sidebar.classList.toggle('mobile-open');
            if (sidebar.classList.contains('mobile-open')) {
                overlay?.classList.add('active');
            } else {
                overlay?.classList.remove('active');
            }
        }
    }

    function closeMobileSidebar() {
        if (window.innerWidth < 1024) {
            sidebar.classList.remove('mobile-open');
            overlay?.classList.remove('active');
        }
    }

    function initSidebarState() {
        if (window.innerWidth >= 1024) {
            const isCollapsed = localStorage.getItem('sidebarCollapsed') === 'true';
            if (isCollapsed) {
                sidebar.classList.add('collapsed');
            }
            updateSidebarToggleIcon(isCollapsed);
        }
    }

    function scrollToActiveLink() {
        const activeLink = document.querySelector('.sidebar-link.active');
        if (activeLink) {
            // Wait for potential transitions or rendering
            setTimeout(() => {
                activeLink.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center'
                });
            }, 100);
        }
    }

    function initActiveLink() {
        const currentUrl = window.location.href;
        const origin = window.location.origin;

        sidebarLinks.forEach(link => {
            link.classList.remove('active');
            const linkHref = link.getAttribute('href');

            if (linkHref && linkHref !== '#') {
                if (currentUrl === linkHref) {
                    link.classList.add('active');
                } else if (currentUrl.startsWith(linkHref) && linkHref !== origin + '/admin' && linkHref !== origin + '/user' && linkHref !== origin + '/index.html') {
                    link.classList.add('active');
                }
            }
        });

        scrollToActiveLink();
    }

    // Events
    if (toggleBtn) toggleBtn.addEventListener('click', toggleSidebar);
    if (toggleBtnMobile) toggleBtnMobile.addEventListener('click', toggleSidebar);
    if (closeBtnMobile) closeBtnMobile.addEventListener('click', closeMobileSidebar);
    if (overlay) overlay.addEventListener('click', closeMobileSidebar);

    window.addEventListener('resize', () => {
        if (window.innerWidth >= 1024) {
            sidebar.classList.remove('mobile-open');
            overlay?.classList.remove('active');
        }
    });

    initSidebarState();
    initActiveLink();
}

// Auto init
document.addEventListener('DOMContentLoaded', initSidebar);
